import React, { useEffect } from "react"
import ReactPopup from "reactjs-popup"
import styled from "styled-components"
import CloseIcon from "../../resources/img/ui/popup/popup-close-white.svg"

const contentStyle = {
  width: "100vw",
  height: "auto",
  margin: "auto",
  background: "transparent",
  boxSizing: "border-box",
  overflow: "auto",
}

const overlayStyle = {
  overflowY: "auto",
  background: "rgba(0, 0, 0, 0.45)",
}

const CloseButton = styled.button`
  position: fixed;
  top: 15px;
  right: 15px;
  background: transparent;
  border: none;
  cursor: pointer;
  display:flex;
  align-items: center;
  justify-content: center;

  img {
    width: 15px;
    height: 15px;
  }
`

const generateMeetingUrl = (type, queryStrings, meetingType) => {
  const baseUrls = {
    "By video call": "https://meetings-eu1.hubspot.com/kimai",
    "Paris appointment": "https://meetings-eu1.hubspot.com/kimai-fr",
    "London showroom": "https://meetings-eu1.hubspot.com/london-store",
    "London showroom - wedding bands": "https://meetings-eu1.hubspot.com/kimai/weddingbands-chiltern",
    "By phone": "https://meetings-eu1.hubspot.com/kimai/phone-calls",
    "Brussels pop up": "https://meetings-eu1.hubspot.com/kimai/bruxelles-pop-up",
    "LA Trunkshow": "https://meetings-eu1.hubspot.com/kimai/los-angeles-trunkshow",
    "LA Trunk Show": "https://meetings-eu1.hubspot.com/kimai/los-angeles-trunkshow",
    "New York Trunkshow": "https://meetings-eu1.hubspot.com/kimai/new-york-trunkshow",
    "Toronto Trunkshow": "https://meetings-eu1.hubspot.com/kimai/toronto-trunkshow"
  }

  let baseUrl = baseUrls[type] || "https://meetings-eu1.hubspot.com/kimai"

  if (meetingType === "Wedding bands" && type === "London showroom") {
    baseUrl = baseUrls["London showroom - wedding bands"]
  }

  return `${baseUrl}?embed=true&${queryStrings || ""}`
}

const MeetingPopup = ({
  type,
  meetingType,
  queryStrings,
  open,
  setPopupOpen,
  setSuccess,
  setSubmitted,
  initializeHubspotForm,
}) => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const script = document.createElement("script")
      script.src =
        "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"
      script.async = true
      document.body.appendChild(script)

      return () => {
        document.body.removeChild(script)
      }
    }
  }, [open])

  useEffect(() => {
    const handleMessage = (e) => {
      if (e.data.meetingBookSucceeded === true) {
        setPopupOpen(false)
        setSuccess(true)
      }
    }

    window.addEventListener("message", handleMessage)

    return () => {
      window.removeEventListener("message", handleMessage) // Cleanup by removing the event listener
    }
  }, [setPopupOpen, setSuccess])

  const handleClose = () => {
    setPopupOpen(false)
    setSubmitted(false)
    initializeHubspotForm()
  }

  const meetingUrl = generateMeetingUrl(type, queryStrings, meetingType)

  return (
    <ReactPopup
      open={open}
      overlayStyle={overlayStyle}
      contentStyle={contentStyle}
      onClose={() => handleClose()}
      closeOnEscape
    >
      <CloseButton onClick={() => handleClose()}>
        <img src={CloseIcon} alt="close popup" />
      </CloseButton>
      <div className="meetings-iframe-container" data-src={meetingUrl} />
    </ReactPopup>
  )
}

export default MeetingPopup
